import React, { useEffect, useState } from "react";
import { Typography, Table, Button, message } from "antd";
import { useParams } from "react-router-dom";

const { Title } = Typography;

function TransferTask() {

  const { projectId } = useParams();
  const [tasks, setTasks] = useState([]);

  useEffect(() => {

    const fetchTasks = async () => {

      try {

        const token = localStorage.getItem("access-token");

        const res = await fetch(
          `https://rhrmapi.up2dateinc.com/api/tasks/project/${projectId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );

        const data = await res.json();

        if (Array.isArray(data)) {
          setTasks(data);
        } else {
          setTasks([]);
        }

      } catch (error) {

        message.error("Failed to load tasks");

      }

    };

    fetchTasks();

  }, [projectId]);

  const transferTask = (task) => {

    message.success(`Task "${task.summary}" transferred to Sprint`);

  };

  const columns = [
    {
      title: "SL No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Summary",
      dataIndex: "summary",
    },
    {
      title: "Reporter",
      dataIndex: "reporter",
    },
    {
      title: "Assignee",
      dataIndex: "assignee",
    },
    {
      title: "Priority",
      dataIndex: "priority",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Action",
      render: (_, record) => (
        <Button
          type="primary"
          onClick={() => transferTask(record)}
        >
          Transfer
        </Button>
      ),
    },
  ];

  return (
    <div>

      <Title level={3}>Transfer Tasks</Title>

      <Table
        columns={columns}
        dataSource={Array.isArray(tasks) ? tasks : []}
        rowKey="_id"
        pagination={{ pageSize: 5 }}
      />

    </div>
  );
}

export default TransferTask;